export const mapProductDto = (dto) => ({
    id: dto.id,
    name: dto.name,
    sku: dto.sku,
    category: dto.category,
    description: dto.description,
    unit: dto.unit,
    unitCode: dto.unit_code,
    listPrice: Number(dto.list_price ?? 0),
    vatRate: Number(dto.vat_rate ?? 0),
    isActive: dto.is_active ?? true,
    organisationId: dto.organisation_id,
    createdAt: dto.created_at,
    updatedAt: dto.updated_at,
});

/** Frontend shape → API payload (snake_case). */
export const toProductPayload = (product) => ({
    name: product.name,
    sku: product.sku || null,
    category: product.category || null,
    description: product.description || null,
    unit: product.unit || 'Stk',
    unit_code: product.unitCode || 'C62',
    list_price: Number(product.listPrice) || 0,
    vat_rate: Number(product.vatRate) || 0,
    is_active: product.isActive !== false,
});
